import React from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { Grid, Form } from 'semantic-ui-react'
import { reduxForm } from 'redux-form'
import flowRight from 'lodash/flowRight'
import { LKIcon, LKButton } from 'loankeeper-common/components'
import { GridContainer } from 'shared/StyledComponents'
import FormField from 'shared/newFormElements'
import { getPending as getPendingFetcher } from 'loankeeper-common/helpers/SimpleFetchManager'
import LKModal, { LKModalContainer, actions as LKModalActions } from 'shared/LKModal'
import translate, { translateDialog } from './translate'
import { addToBlacklist, removeFromBlackList } from 'src/store/client'

const addClientToBlackListFetcher = 'addClientToBlackListFetcher'
const addClientToBlackListModal = 'addClientToBlackListModal'
const undoAddClientToBlackListFetcher = 'undoAddClientToBlackListFetcher'
const undoAddClientToBlackListModal = 'undoAddClientToBlackListModal'
const BLACK_LIST_CLIENT_FORM = 'black-list-client-form'

const Textarea = styled(FormField)`
  max-height: 66px;
`

const LKButtonOkay = styled(LKButton)`
  width: 120px;
`

const AddClientToBlackListModal = flowRight(
  LKModalContainer(addClientToBlackListModal),
  reduxForm({
    form: BLACK_LIST_CLIENT_FORM,
    onSubmit: async ({ comment }, dispatch, { params: { ID, hash, onFinish } }) => {
      // dispatch(
      //   fetchSFM({
      //     instanceName: addClientToBlackListFetcher,
      //     callApi: Client.addToBlackList,
      //     callApiArgs: [ID, hash, comment],
      //     resolve: onFinish,
      //   }),
      // )

      dispatch(LKModalActions.close(addClientToBlackListModal))
      //UPDATED API REQUEST client_oper_api page: blacklist
      const res = await dispatch(
        addToBlacklist({
          ClientID: ID,
          HashSum_ClientID_: hash,
          Comment: comment,
        }),
      )
      if (addToBlacklist.fulfilled.match(res)) {
        onFinish()
      } else if (addToBlacklist.rejected.match(res)) {
        LKModalActions.openError(translate('LKMESSAGE', res.payload.message))
      }
    },
  }),
)(({ modalInstanceName, handleSubmit, invalid, submitting }) => (
  <LKModal
    name={modalInstanceName}
    heading={translate('MSG_CONFIRM')}
    size="xs"
    footer={
      <LKModal.Footer>
        <LKButtonOkay alias="ok" onClick={handleSubmit} disabled={invalid || submitting} loading={submitting}>
          {translateDialog('cmd_finish')}
        </LKButtonOkay>
        <LKModal.CancelButton text={translateDialog('cmd_cancel')} />
      </LKModal.Footer>
    }
  >
    <div className="u-flex u-alignCenter u-justifyCenter" style={{ minHeight: 55 }}>
      <LKIcon alias="question" style={{ marginRight: 5 }} />
      {translate('CONFIRM_BLACK_ADD')}
    </div>
    <Form onSubmit={handleSubmit}>
      <GridContainer>
        <Grid>
          <Grid.Row>
            <Grid.Column width={16}>
              <label htmlFor="blacklist-reason">{translate('PROMPT_BLACK')}</label>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{ marginTop: 10 }}>
            <Grid.Column width={16}>
              <Textarea id="blacklist-reason" type="textarea" name="comment" />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </GridContainer>
    </Form>
  </LKModal>
))

const UndoAddClientToBlackListModal = () => {
  const dispatch = useDispatch()

  async function handleConfirm({ ID, hash, onFinish }) {
    // dispatch(
    //   fetchSFM({
    //     instanceName: undoAddClientToBlackListFetcher,
    //     callApi: Client.undoAddToBlackList,
    //     callApiArgs: [ID, hash],
    //     resolve: onFinish,
    //   }),
    // )

    //UPDATED API REQUEST client_oper_api page: blacklistundo
    const res = await dispatch(
      removeFromBlackList({
        ClientID: ID,
        HashSum_ClientID_: hash,
      }),
    )
    if (removeFromBlackList.fulfilled.match(res)) {
      onFinish()
    } else if (removeFromBlackList.rejected.match(res)) {
      LKModalActions.openError(translate('LKMESSAGE', res.payload.message))
    }
  }

  return <LKModal.Confirmation name={undoAddClientToBlackListModal} onConfirm={handleConfirm} />
}

const ClientBlackListModal = () => (
  <>
    <AddClientToBlackListModal />
    <UndoAddClientToBlackListModal />
  </>
)

export default ClientBlackListModal

export const open = (ID, hash, black, onFinish) =>
  black === 0
    ? LKModalActions.open({ name: addClientToBlackListModal, ID, hash, onFinish })
    : LKModalActions.openConfirmation(undoAddClientToBlackListModal, {
        message: translate('CONFIRM_BLACK_RESTORE'),
        ID,
        hash,
        onFinish,
      })

export const getPending = (state) =>
  getPendingFetcher(addClientToBlackListFetcher)(state) === true ||
  getPendingFetcher(undoAddClientToBlackListFetcher)(state) === true
